<template>
  <li
    v-if="category.stagedProductCount"
    class="lg:text-center break-words"
    :data-testid="dataTestid"
    @click="handleItemClick"
  >
    <component
      :is="componentTag"
      v-bind="componentProperties"
      :class="{'cursor-pointer': shouldSetFirstLevelCategory}"
    >
      <div class="h-auto rounded overflow-hidden">
        <SectionTransition
          :has-content="Boolean(categoryImageUrl)"
          client-only
        >
          <ImgView
            :src="categoryImageUrl"
            :alt="category.name"
            img-classes="w-full h-auto overflow-hidden rounded"
          />
        </SectionTransition>
      </div>
      <span
        class="block text-center text-EXPONDO-black text-sm lg:text-base"
        :itemprop="hasSchema ? SCHEMA_ITEM_PROP.NAME : undefined"
      >
        {{ category.name }}
      </span>
    </component>
  </li>
</template>
<script lang="ts">

import type { Category } from '~~/types/commercetools';

import { SCHEMA_ITEM_PROP } from '~~/constants/seo';
import { getCategoryImgUrl } from '~~/helpers/category/customFields/index';
import { buildCategoryPageUrl } from '~~/helpers/category/buildCategoryPageUrl';
import SimpleLink from '~/components/atoms/SimpleLink/SimpleLink.vue';

export default defineComponent({
  name: 'NavCategoryListItem',
  components: {
    SimpleLink,
  },
  props: {
    category: {
      type: Object as PropType<Category>,
      required: true,
    },
    hasSchema: {
      type: Boolean,
      default: false,
    },
    shouldSetFirstLevelCategory: {
      type: Boolean,
      default: false,
    },
    dataTestid: {
      type: String,
      default: undefined,
    },
  },
  setup(props: {category: Category, hasSchema: boolean, shouldSetFirstLevelCategory: boolean}) {

    const { toggleNavigation, setFirstLevelCategory } = useNavigationState();
    const { countryCode } = useLocalization();
    const targetCategoryUrl = computed(() => buildCategoryPageUrl({
      category: props.category.slug,
      countryCode: countryCode.value,
    }));
    const handleItemClick = () => {

      if (props.shouldSetFirstLevelCategory) {

        return setFirstLevelCategory(props.category.slug);
      
      }
      toggleNavigation();
    
    };
    const categoryImageUrl = computed(() => getCategoryImgUrl(props.category));
    const componentTag = computed(() => props.shouldSetFirstLevelCategory ? 'div' : resolveComponent('SimpleLink'));
    const simpleLinkProps = {
      to: targetCategoryUrl.value,
      itemprop: props.hasSchema ? SCHEMA_ITEM_PROP.URL : undefined,
    };
    const componentProperties = computed(() => props.shouldSetFirstLevelCategory ? {} : simpleLinkProps);

    return {
      targetCategoryUrl,
      handleItemClick,
      SCHEMA_ITEM_PROP,
      categoryImageUrl,
      componentTag,
      componentProperties,
    };
  
  },
});

</script>
